/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesRosterSchema } from "./rosterSchema.ts";
import { goodLuckCoreEntitiesTeamAccessRoleSchema } from "./teamAccessRoleSchema.ts";
import { goodLuckCoreEntitiesTeamRoleSchema } from "./teamRoleSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesRosterMemberSchema = z.object({
  id: z.string().nullish(),
  teamId: z.string().nullish(),
  userId: z.string().nullish(),
  get role() {
    return goodLuckCoreEntitiesTeamRoleSchema.optional();
  },
  get accessRole() {
    return goodLuckCoreEntitiesTeamAccessRoleSchema.optional();
  },
  joinedAt: z.optional(z.iso.datetime()),
  joinedVia: z.string().nullish(),
  get team() {
    return goodLuckCoreEntitiesRosterSchema.optional();
  },
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
});
